export default __webpack_public_path__ + "static/media/search-icon.3613a1b4.svg";